<template>
  <div>
    <Breadcrumb :items="breadcrumbItems" />
    
    <ProgramaForm
      @save="handleSave"
      @cancel="handleCancel"
      @error="handleError"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import ProgramaForm from "../../../components/forms/ProgramaForm.vue";
import { ProgramaService } from "../../../services/ProgramaService";

export default {
  name: "CriarPrograma",
  components: {
    Breadcrumb,
    ProgramaForm
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "Página Inicial",
          disabled: false,
          href: "/"
        },
        {
          text: "Gerenciamento de Programas",
          disabled: false,
          href: "/gerenciar-programas"
        },
        {
          text: "Cadastrar Programa",
          disabled: true,
          href: "/programas/criar"
        }
      ]
    };
  },
  methods: {
    async handleSave(formData) {
      try {
        // Criar FormData seguindo o padrão existente
        const postData = new FormData();
        
        postData.append("exercicio", formData.exercicio);
        postData.append("codigo_programa", formData.codigo_programa);
        postData.append("descricao", formData.descricao);
        postData.append("ativo", formData.ativo ? 1 : 0);
        
        const response = await ProgramaService.store(postData);
        
        if (response) {
          // Exibir mensagem de sucesso
          this.$store.dispatch('snackbar/showMessage', {
            message: 'Programa salvo com sucesso!',
            color: 'success'
          });
          
          // Redirecionar para a lista de Programas após salvar
          this.$router.push('/gerenciar-programas');
        } else {
          throw new Error('Erro ao criar Programa');
        }
      } catch (error) {
        console.error('Erro ao criar Programa:', error);
        this.$store.dispatch('snackbar/showMessage', {
          message: 'Erro ao salvar programa. Tente novamente.',
          color: 'error'
        });
        throw error;
      }
    },
    
    handleCancel() {
      // Retornar para a tela principal do menu
      this.$router.push('/gerenciar-programas');
    },
    
    handleError(message) {
      this.$store.dispatch('snackbar/showMessage', {
        message: message,
        color: 'error'
      });
    }
  }
};
</script>

<style scoped>
/* Estilos específicos da página, se necessário */
</style>